module.exports = __webpack_public_path__ + "static/img/Gorlitz.11e78e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LogosExperten/Gorlitz.png
// module id = 116
// module chunks = 0